<template>
  <div>
    <v-form
      ref="FilterSpeedForm"
      class="ml-4 mr-4"
      @submit.prevent="filter()"
    >
      <div class="d-flex justify-space-between">
        <slot />
      </div>
    </v-form>
  </div>
</template>

<script>
export default {
  name: 'FilterSpeedTemplate',
  methods: {
    filter() {
      this.$emit('submit');
    },
  },
};
</script>
